import {Route} from 'react-router'
import LoggedRoute from '@freckle/school/ts/common/routers/logged-route'
import CleanUpRosterHandler from './../../../../rostering/components/clean-up-roster/index'
import RemoveSelfRosteredTeachersHandler from './../../../../rostering/components/clean-up-roster/remove-self-rostered-teachers/index'
import ImportRosterHandler from './../../../../rostering/components/import-roster/index'

export default function RouterV2Rostering() {
  return (
    <>
      <Route
        path="/rostering/import-roster"
        element={
          <LoggedRoute component={ImportRosterHandler} wrapperParams={{tabId: 'teachers'}} />
        }
      />
      <Route
        path="/rostering/clean-up-roster"
        element={
          <LoggedRoute component={CleanUpRosterHandler} wrapperParams={{tabId: 'teachers'}} />
        }
      />
      <Route
        path="/rostering/clean-up-roster/remove-self-rostered-teachers"
        element={
          <LoggedRoute
            component={RemoveSelfRosteredTeachersHandler}
            wrapperParams={{tabId: 'teachers'}}
          />
        }
      />
    </>
  )
}
